import { motion } from "framer-motion";
import { PROCESS, IMAGES, CONTACT } from "@/data/site";

export default function Process() {
  return (
    <section id="process" className="relative py-24 lg:py-32 bg-[#0a0a0a] border-y border-white/10" data-testid="process-section">
      <div className="max-w-7xl mx-auto px-6 grid grid-cols-1 lg:grid-cols-2 gap-16 items-start">
        <div className="lg:sticky lg:top-28">
          <span className="font-mono text-xs tracking-[0.3em] uppercase text-gold">The Aftermath Method</span>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl mt-4 leading-tight">
            A calm plan for<br /><span className="text-gradient-gold">chaotic moments.</span>
          </h2>
          <p className="mt-6 text-[#A3A3A3] max-w-md leading-relaxed">
            Disaster is disorienting. Our process gives you clarity from the first phone call, we secure, document and restore while keeping you informed at every step.
          </p>
          <motion.div
            initial={{ opacity: 0, scale: 0.98 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.8 }}
            className="mt-10 relative overflow-hidden border border-white/10 h-64"
          >
            <img src={IMAGES.process} alt="Certified restoration crew at work" className="h-full w-full object-cover opacity-75" />
            <div className="absolute inset-0 bg-gradient-to-t from-[#0a0a0a] to-transparent" />
            <div className="absolute bottom-5 left-5">
              <p className="font-mono text-xs text-gold tracking-widest">DISPATCH LINE</p>
              <a href={CONTACT.phoneHref} className="font-display text-2xl text-[#F5F5F0] hover:text-gold transition-colors" data-testid="process-call-link">{CONTACT.phone}</a>
            </div>
          </motion.div>
        </div>

        <div className="space-y-12">
          {PROCESS.map((p, i) => (
            <motion.div
              key={p.num}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.4 }}
              transition={{ duration: 0.7, delay: i * 0.1, ease: [0.16, 1, 0.3, 1] }}
              className="border-b border-white/10 pb-12 last:border-0"
              data-testid={`process-step-${p.num}`}
            >
              <div className="flex items-baseline gap-6">
                <span className="font-mono text-gold text-sm tracking-widest">{p.num}</span>
                <div>
                  <h3 className="font-display text-3xl sm:text-4xl">{p.title}</h3>
                  <p className="mt-4 text-[#A3A3A3] leading-relaxed text-lg">{p.desc}</p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
